export default __webpack_public_path__ + "static/primarius-trans-logo-92349fee6e15eb6fc9777b72abee13fd.png";